var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i18n-n',{attrs:{"value":_vm.formatValue,"format":_vm.currency ? 'currency' : null,"locale":_vm.localee},scopedSlots:_vm._u([{key:"currency",fn:function(ref){
var currency = ref.currency;
return [_vm._v(_vm._s(currency))]}},{key:"fraction",fn:function(ref){
var fraction = ref.fraction;
return [_vm._v(_vm._s(("" + fraction + _vm.abbreviation)))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }